import CityPageTemplate from "@/pages/hawaii-city/CityPageTemplate";
import { wahiawaConfig } from "./data";

export default function WahiawaPage() {
  return <CityPageTemplate config={wahiawaConfig} />;
}